module.exports = __webpack_public_path__ + "media/flags/mz-c1b9bea7.svg";